import React, { useState } from 'react';
import { func } from 'prop-types';
import {
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@material-ui/core';
import { SentimentVeryDissatisfiedOutlined } from '@material-ui/icons';
import { withAppContextHOC } from 'Scenes/_root/appContext';
import {
  MeetingContextMeetingControlsProps,
  withMeetingContext,
} from 'Scenes/_root/meetingContext';
import styles from './styles.scss';

export const MeetingFeedback = ({ meetingControls, onClose }) => {
  const [feedbackText, setFeedbackText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOnChange = (event) => {
    setFeedbackText(event.target.value);
  };
  const submitFeedback = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    meetingControls.submitFeedback(feedbackText, false);
    window.setTimeout(() => {
      onClose();
    }, 2000);
  };
  return (
    <div className={styles.feedbackSubmitWrapper}>
      <Typography variant='h2'>
        <SentimentVeryDissatisfiedOutlined fontSize='inherit' />
      </Typography>
      <Typography variant='body1'>
        Sorry to hear that your TeleConsult experience has not been great. Please let us know what didn’t work as expected so we can continue to develop and improve TeleConsult.
      </Typography>
      <form onSubmit={submitFeedback}>
        <TextField
          autoFocus
          fullWidth
          multiline
          required
          disabled={isSubmitting}
          margin='dense'
          name='name'
          onChange={handleOnChange}
          placeholder='Enter your feedback'
          rowsMax={5}
          size='small'
          value={feedbackText}
          variant='outlined'
        />
        <div className={styles.feedbackSubmitButtonWrapper}>
          <Button
            fullWidth
            color='primary'
            disabled={isSubmitting || feedbackText.length === 0}
            type='submit'
            variant='contained'
          >
            Submit feedback
          </Button>
          { isSubmitting && <CircularProgress className={styles.buttonProgress} size={24} /> }
        </div>
      </form>
    </div>
  );
};

MeetingFeedback.propTypes = {
  onClose: func.isRequired,
  meetingControls: MeetingContextMeetingControlsProps,
};

export default withMeetingContext([
  'meetingControls',
])(withAppContextHOC(['isLoggedIn', 'identityEmail'])(MeetingFeedback));
